module.exports = __webpack_public_path__ + "img/add_arrange.2ba4af0b.png";